import React, { Component } from 'react';
import { isOnScreen } from '../resources/animationfunction';
import Banner from '../stores/home/Banner';
import FeaturedIn from '../stores/home/FeaturedIn';
import GetStarted from '../components/getstarted/get-started';
import GoodCompany from '../stores/home/GoodCompany';
import GoogleAddSense from '../stores/home/GoogleAddSense';
import SocialInWebtalk from '../stores/home/SocialInWebtalk';
import SuccessStory from '../stores/home/SuccessStory';
import WebTalkAddReward from '../stores/home/WebTalkAddReward';
import '../stores/home/home.css';

class Home extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		document.querySelectorAll('.animate-fade').forEach((item, index) => {
			if (isOnScreen(document.querySelectorAll('.animate-fade')[index])) {
				setTimeout(function () {
					document
						.querySelectorAll('.animate-fade')
						[index].classList.add('animation-in');
				});
			}
		});
	}

	render() {
		return (
			<section className='wrapper home'>
				{/* <Header/> */}
				<Banner />
				<FeaturedIn />
				<SocialInWebtalk />
				<GoodCompany />
				<WebTalkAddReward />
				<GoogleAddSense />
				<SuccessStory />
				<GetStarted />
				{/* <Footer/> */}
			</section>
		);
	}
}

export default Home;
